import { Group, Button, TextInput, NumberInput, Switch } from '@mantine/core';

import { useUpdateConversionPair } from '../hooks/use-update-conversion-pair';
import { getConversionPairTitle } from '../utils/helpers/converter';

import type { TConversionPair } from '../store/types';

type Props = {
  conversionPair: TConversionPair;
  onClose: () => void;
};

export const EditConversionPairForm = (props: Props) => {
  const { conversionPair, onClose } = props;
  const {
    form,
    isLoading,
    autoRefresh,
    handleSubmit,
  } = useUpdateConversionPair({ conversionPair, onClose });

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <TextInput
        label="Торговая пара"
        disabled
        value={getConversionPairTitle(conversionPair)}
      />
      <Switch
        mt={10}
        label="Автоматически обновлять курс"
        key={form.key('autoRefresh')}
        {...form.getInputProps('autoRefresh', { type: 'checkbox' })}
      />
      <NumberInput
        label="Курс"
        withAsterisk
        disabled={autoRefresh}
        min={0}
        decimalScale={18}
        key={form.key('rate')}
        {...form.getInputProps('rate')}
      />
      <NumberInput
        label="Наценка (%)"
        decimalScale={10}
        key={form.key('markupPercent')}
        {...form.getInputProps('markupPercent')}
      />

      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit" loading={isLoading}>
          Редактировать
        </Button>
      </Group>
    </form>
  );
};
